export const MAPPING_ERRORS = ["INDICATOR_EMPTY", "INDICATOR_UNKNOWN", "INDICATOR_AMBIGUOUS"];

export function rowErrors(row) {
  return Array.isArray(row.errors) ? row.errors : [];
}

export function hardErrors(row) {
  return rowErrors(row).filter(error => MAPPING_ERRORS.indexOf(error.code) < 0);
}

export function previewCanConfirm(preview, mapping) {
  return Boolean(preview && preview.fingerprint && preview.rows && preview.rows.length && Array.isArray(preview.indicators) &&
    preview.rows.every(row => hardErrors(row).length === 0 &&
      preview.indicators.some(indicator => String(indicator.idIndikator) === String(mapping[row.rowNumber] || ""))));
}

export function readableText(html) {
  if (!html) return "";
  const doc = new DOMParser().parseFromString(String(html), "text/html");
  return doc.body.textContent || "";
}

export function detailValidation(type, rows) {
  if (!Array.isArray(rows) || !rows.length || rows.length > 500) return "Isi 1 sampai 500 rincian soal sebelum menyimpan.";
  if (rows.some(row => !row.pernyataan || !String(row.pernyataan).trim())) return "Isi teks setiap pernyataan dan jawaban.";
  if (type === "BNS") return rows.some(row => ["0", "1"].indexOf(String(row.kunciJawaban)) < 0) ? "Pilih Benar atau Salah pada setiap pernyataan." : "";
  const ids = rows.map(row => String(row.id));
  if (ids.some(id => !/^[1-9][0-9]*$/.test(id)) || new Set(ids).size !== ids.length) return "Rincian pasangan belum sah. Muat ulang soal lalu periksa kembali.";
  const answers = rows.filter(row => row.kunciJawaban === null).map(row => String(row.id));
  const questions = rows.filter(row => row.kunciJawaban !== null);
  if (!answers.length || !questions.length) return "Tambahkan pernyataan dan pilihan jawaban untuk soal menjodohkan.";
  if (questions.some(row => answers.indexOf(String(row.kunciJawaban)) < 0)) return "Pasangkan setiap pernyataan dengan jawaban yang tersedia.";
  return "";
}

export function apiMessage(error) {
  const status = error && error.response && error.response.status;
  if (status === 401) return "Sesi berakhir. Silakan masuk kembali.";
  if (status === 403) return "Akun Anda tidak memiliki izin untuk tindakan ini.";
  const payload = error && error.response && error.response.data;
  const message = payload && payload.errorSchema && payload.errorSchema.errorMessage;
  if (message) return message;
  if (status === 409) return "Data berubah atau sudah dipakai. Muat ulang sebelum melanjutkan.";
  return error && error.publicMessage || "Layanan belum dapat dihubungi. Periksa koneksi lalu coba kembali.";
}

export function unwrap(response) {
  const payload = response && response.data;
  if (!payload || !payload.errorSchema || payload.errorSchema.errorCode !== "EP-000") {
    const error = new Error("Request failed");
    error.response = response;
    error.publicMessage = payload && payload.errorSchema && payload.errorSchema.errorMessage;
    throw error;
  }
  return payload.data;
}
